var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"todoapp"},[_c('todo-header'),_c('todo-main'),_c('todo-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }